module.exports = __webpack_public_path__ + "static/media/2.65da3c25.png";